module.exports = __webpack_public_path__ + "static/media/scenario-assistant.fa2338da.png";